module.exports = __webpack_public_path__ + "static/media/iPhone3.5d0805b2.png";